import { lazy } from 'react';
import LazyComponent from './LazyLoaded';

const CreateNewEmail = LazyComponent(lazy(() => import('./CreateEmail')));
const EmailEditor = LazyComponent(lazy(() => import('./Editor')));

export { CreateNewEmail, EmailEditor };
